import { useContext } from 'react';

import { OverlayStackingContext } from '../contexts/OverlayStacking.js';
import type { WithChildren } from '../types/with-children.js';

/**
 * Provider that can be reused in components that can
 * create another level of modal/overlays for correct z-index stacking
 * @public
 */
export const OverlayStackingProvider = ({ children }: WithChildren) => {
  const currentLevel = useContext(OverlayStackingContext);
  // The context is already typed and only accepts valid values and increasing by 1
  // with every nesting level
  const nestingLevel = currentLevel + 1;
  return (
    <OverlayStackingContext.Provider value={nestingLevel}>
      {children}
    </OverlayStackingContext.Provider>
  );
};
OverlayStackingProvider.displayName = 'OverlayStackingProvider';
